function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { JOSENotSupported } from '../util/errors.js';

function validateCrit(Err, recognizedDefault, recognizedOption, protectedHeader, joseHeader) {
  if (joseHeader.crit !== undefined && protectedHeader.crit === undefined) {
    throw new Err('"crit" (Critical) Header Parameter MUST be integrity protected');
  }

  if (!protectedHeader || protectedHeader.crit === undefined) {
    return new Set();
  }

  if (!Array.isArray(protectedHeader.crit) || protectedHeader.crit.length === 0 || protectedHeader.crit.some(function (input) {
    return typeof input !== 'string' || input.length === 0;
  })) {
    throw new Err('"crit" (Critical) Header Parameter MUST be an array of non-empty strings when present');
  }

  var recognized;

  if (recognizedOption !== undefined) {
    recognized = new Map([].concat(_toConsumableArray(Object.entries(recognizedOption)), _toConsumableArray(recognizedDefault.entries())));
  } else {
    recognized = recognizedDefault;
  }

  var _iterator = _createForOfIteratorHelper(protectedHeader.crit),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var parameter = _step.value;

      if (!recognized.has(parameter)) {
        throw new JOSENotSupported("Extension Header Parameter \"".concat(parameter, "\" is not recognized"));
      }

      if (joseHeader[parameter] === undefined) {
        throw new Err("Extension Header Parameter \"".concat(parameter, "\" is missing"));
      } else if (recognized.get(parameter) && protectedHeader[parameter] === undefined) {
        throw new Err("Extension Header Parameter \"".concat(parameter, "\" MUST be integrity protected"));
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return new Set(protectedHeader.crit);
}

export default validateCrit;